import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPaintBucket: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconPaintBucket"><Path d="M19.5 21.5H4.5V10C4.5 5.85786 7.85786 2.5 12 2.5C16.1421 2.5 19.5 5.85786 19.5 10V21.5Z" stroke="currentColor"/><Path d="M3 10.5H21" stroke="currentColor"/><Path d="M8.5 10.5V15" stroke="currentColor"/><Path d="M10.5 10.5V13" stroke="currentColor"/></CentralIconBase>;
});

export default IconPaintBucket;
